export default "/images/ic_address.svg?fb4b5558cfba0097f69461d330180e0c";